import {Component, Input} from '@angular/core';

enum ReachStatusEnum {
  ASC = 'asc',
  DESC = 'desc'
}

@Component({
  selector: 'achoo-gauge-circle-chart-content',
  templateUrl: './achoo-gauge-circle-chart-content.component.html',
  styleUrls: ['./achoo-gauge-circle-chart-content.component.scss']
})
export class AchooGaugeCircleChartContentComponent {

  @Input()
  public reachValue: number;

  @Input()
  public reachStatus: string;

  @Input()
  public  reachPercent: number;

  @Input()
  public reachLabel: string;

  @Input()
  public tooltipInfo: string;

  @Input()
  public isTitleOnTop = false;

  @Input()
  public isChannelFollower = false;

  hasAscendingStatus(status) {
    return status === ReachStatusEnum.ASC;
  }

  hasDescendingStatus(status) {
    return status === ReachStatusEnum.DESC;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-gauge-circle-chart-content/achoo-gauge-circle-chart-content.component.ts